import Marquee from "react-fast-marquee";

const PHRASES = [
  "Precision hiring",
  "Human first",
  "48-hour shortlists",
  "Talent, aligned",
  "Teams that ship",
  "Partners, not vendors",
];

export const EditorialMarquee = () => (
  <div className="border-y border-slate-200/90 py-10 bg-slate-50 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {PHRASES.map((p, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-editorial italic text-4xl sm:text-5xl text-slate-400 px-8">{p}</span>
          <span className="text-brand text-2xl">/</span>
        </span>
      ))}
    </Marquee>
  </div>
);
